// Enterprise Multi-Variant Realtime Summation Engine Block
(function() {
  function formatIndustryMoney(cents) {
    return "Rs. " + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function recalculateIndustryTotals(section) {
    var uid = section.id.replace('bundle-container-', '');
    var currentSum = 0;
    var compareSum = 0;
    var activeCount = 0;

    section.querySelectorAll('.ind-bundle-row-item').forEach(function(row) {
      var checker = row.querySelector('.ind-bundle-checker');
      if (checker && checker.checked) {
        currentSum += parseFloat(row.getAttribute('data-price')) || 0;
        compareSum += parseFloat(row.getAttribute('data-compare-price')) || 0;
        activeCount++;
        row.classList.add('is-checked');
      } else {
        row.classList.remove('is-checked');
      }
    });

    var currentPriceEl = document.getElementById('total-sum-' + uid);
    var comparePriceEl = document.getElementById('compare-sum-' + uid);
    var savingsBannerEl = document.getElementById('savings-banner-' + uid);
    var savingsSumEl = document.getElementById('savings-sum-' + uid);
    var submitBtn = document.getElementById('submit-' + uid);

    if (currentPriceEl) currentPriceEl.innerText = formatIndustryMoney(currentSum);
    if (comparePriceEl) {
      if (compareSum > currentSum) {
        comparePriceEl.innerText = formatIndustryMoney(compareSum);
        comparePriceEl.style.display = 'inline';
      } else {
        comparePriceEl.style.display = 'none';
      }
    }

    if (savingsBannerEl && savingsSumEl) {
      if (compareSum > currentSum) {
        savingsSumEl.innerText = formatIndustryMoney(compareSum - currentSum);
        savingsBannerEl.style.display = 'block';
      } else {
        savingsBannerEl.style.display = 'none';
      }
    }

    if (submitBtn) {
      if (activeCount === 0) {
        submitBtn.disabled = true;
        submitBtn.style.opacity = '0.5';
        submitBtn.querySelector('.ind-btn-text').innerText = "Select Items to Continue";
      } else {
        submitBtn.disabled = false;
        submitBtn.style.opacity = '1';
        submitBtn.querySelector('.ind-btn-text').innerText = "Add Entire Pack To Cart";
      }
    }
  }

  window.executeIndustryBundleCheckout = function(uid) {
    var section = document.getElementById('bundle-container-' + uid);
    var itemsQueue = [];

    section.querySelectorAll('.ind-bundle-row-item').forEach(function(row) {
      var checker = row.querySelector('.ind-bundle-checker');
      if (checker && checker.checked) {
        itemsQueue.push({
          id: parseInt(row.getAttribute('data-variant-id')),
          quantity: 1
        });
      }
    });

    if (itemsQueue.length === 0) return;

    var btn = document.getElementById('submit-' + uid);
    var originalText = btn.querySelector('.ind-btn-text').innerText;
    btn.querySelector('.ind-btn-text').innerText = "Adding Package...";

    // Direct Asynchronous REST Pipeline execution
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: itemsQueue })
    })
    .then(function(res) { return res.json(); })
    .then(function() {
      window.location.href = '/cart';
    })
    .catch(function(err) {
      console.error("Cart post error: ", err);
      btn.querySelector('.ind-btn-text').innerText = originalText;
    });
  };

  function mountBundleListeners() {
    document.querySelectorAll('.ind-bundle-wrapper').forEach(function(section) {
      if (section.classList.contains('listeners-mounted')) return;

      section.querySelectorAll('.ind-bundle-checker').forEach(function(checkbox) {
        checkbox.addEventListener('change', function() {
          recalculateIndustryTotals(section);
        });
      });

      recalculateIndustryTotals(section);
      section.classList.add('listeners-mounted');
    });
  }

  document.addEventListener("DOMContentLoaded", mountBundleListeners);
  document.addEventListener("shopify:section:load", function() { setTimeout(mountBundleListeners, 100); });
})();
